import React from 'react';
import { Button, Dialog } from 'sg-styleguide';

import BuilderPlugin from '../plugin/builder-plugin';
import EscapeWrapper from '../helpers/escape-wrapper';

import { FlexWithPadding } from '../helpers';

class Builders extends React.Component{
	render() {
		var pluginsCount = _.size(this.props.builders);
		var pluginNames  = _.map(this.props.builders, 'name').join( ' and ' );

		return(
			<Dialog
				state="warning"
				size={ pluginsCount > 1 ? 'x-large' : 'large' }
				title={window.wizardData.strings.builders_title}
				footer={(
					<div>
						<Button
							color="neutral"
							type="outlined"
							onClick={this.props.onClose}
						>
							{window.wizardData.strings.close}
						</Button>
						<Button
							color="primary"
							onClick={this.props.onConfirm}
						>
							{window.wizardData.strings.confirm}
						</Button>
					</div>
				)}
			>
				{window.wizardData.strings.builders_subtitle.replace( /{ pluginNames }/gi, pluginNames) }

				<FlexWithPadding
					padding={['large', 'none', 'none', 'none']}
					margin="none"
					justify="center"
				>
					{
						this.props.builders.map(plugin =>
							<BuilderPlugin
								key={plugin.id}
								id={plugin.id}
								props{...plugin}
								size={ pluginsCount > 1 ? "6" : "8" }
							/>
						)
					}
				</FlexWithPadding>
			</Dialog>
		);
	}
}

export default EscapeWrapper(Builders);